import React from 'react';
import FooterBase from './footer.base';
import { items } from './data/footer.data';
import Link from 'atomic/utilization/link';
import Container from 'atomic/utilization/container';

import './footer.desktop.scss';

const FooterDesktop: React.FC = () => (
    <FooterBase>
        <Container>
            <div className="footer__main">
                {
                    items.map(item => (
                        <section className="footer__main__section" key={item.label}>
                            <div className="footer__main__section__header">
                                {item.label}
                            </div>
                            <ul className="footer__main__section__list">
                                {
                                    item.items.map(link => (
                                        <li key={link.href}>
                                            <Link href={link.href} target={link.target} rel={link.rel}
                                                size="xs"
                                            >
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))
                                }
                            </ul>
                        </section>
                    ))
                }
            </div>
        </Container>
    </FooterBase>
);

export default FooterDesktop;
